<footer class="main-footer">
  <div class="float-right d-none d-sm-block">
    <strong> {{ TextFooTer }} 
      <a [href]="UrlFooTer">{{ TextFooTerName }}</a>.</strong
    >
  </div>
  <strong>Phần mềm Khảo sát đánh giá <a [routerLink]="['/version-detail']">Version {{version}}</a></strong
  >
</footer>
